import React from 'react';
import styled from 'styled-components';
import Typography from 'components/Typography';
import Spacer from 'components/Spacer';
import Item from './Item';
import { AccordionItem } from './types';


interface Props {
  title?: string,
  items: AccordionItem[],
}


const Accordion:React.FC<Props> = ({
  title,
  items,
}) => {
  const [activeItemId, setActiveItemId] = React.useState<string | null>(null);
  const handleItemClick = (id: string | null) => setActiveItemId(id);
  return (
    <AccordionOuter>
      {title && <Typography variant="h3" as="p">{title}</Typography>}
      <ItemsWrap>
        {items.map((item) => (
          <Spacer my={1} key={item.id}>
            <Item
              active={item.id === activeItemId}
              onClick={handleItemClick}
              {...item}
            />
          </Spacer>
        ))}
      </ItemsWrap>
    </AccordionOuter>
  );
};
export default Accordion;

const AccordionOuter = styled.div``;
const ItemsWrap = styled.div``;
